import { pathOr } from 'ramda'

import { BOARD_PATH } from './base'

const POST_COUNT_PATH = [...BOARD_PATH, '@board/count-posts']

export const postCountSelector = pathOr(0, POST_COUNT_PATH)
